import { Breadcrumbs } from '@intigral/shared';
import { __ } from '../../../../translations';
import useLanguage from '../../../../hooks/useLanguage';
import { Link } from 'react-router-dom';
import { iBreadCrumbProps } from '../../types/iHeaderMenu';

export const Breadcrumb: React.FC<iBreadCrumbProps> = ({ currentProviderLink }) => {
    const language = useLanguage();
    const homeUrl = language === 'en' ? '/en/' : '/';
    const discoverUrl = language === 'en' ? '/en/discover' : '/discover';
    return (
        <Breadcrumbs
            items={[
                {
                    text: __('breadcrumb_home'),
                    href: homeUrl,
                    linkComponent: Link,
                    transformLinkProps: ({ href }) => ({ to: href }),
                },
                {
                    text: __('breadcrumb_partners'),
                    href: discoverUrl,
                    linkComponent: Link,
                    transformLinkProps: ({ href }) => ({ to: href }),
                },

                {
                    text: currentProviderLink.titleLocalized[language ?? 'ar'],
                },
            ]}
        />
    );
};
